<template>
  <div>
    <div class="form-list">
      <div class="form-header">일반</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="X / Y">
          <el-input-number v-model="formModel.x" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.y" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="가로 / 세로">
          <el-input-number v-model="formModel.width" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.height" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="회전">
          <el-input-number v-model="formModel.r" :precision="0" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">대상</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="레이블">
          <el-input v-model="formModel.label" :style="fullField"></el-input>
        </el-form-item>
        <el-form-item label="레이블 보기">
          <el-checkbox v-model="formModel.showLabelFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="레이블 박스 보기">
          <el-checkbox v-model="formModel.showLabelBoxFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="레이블 색">
          <w-color-field v-model="formModel.labelColor" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="레이블 박스 색">
          <w-color-field v-model="formModel.labelBoxColor" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="레이블 크기">
          <el-input-number v-model="formModel.labelOptions.labelSize" :min="1" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
        <el-form-item label="레이블 위치">
          <w-label-position-select v-model="formModel.labelPosition"></w-label-position-select>
        </el-form-item>
        <el-form-item label="폰트">
          <el-select v-model="formModel.labelFont" :style="fullField">
            <el-option v-for="item in MapConst.FONT_FAMILIES" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="폰트 굵기">
          <el-checkbox v-model="formModel.labelOptions.labelBold"></el-checkbox>
        </el-form-item>
        <el-form-item label="이미지 타입">
          <el-radio-group v-model="formModel.styleOptions.imageType">
            <el-radio label="flat">FLAT</el-radio>
            <el-radio label="3d">3D</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="이미지">
          <w-image-select v-model="formModel.customimageId"></w-image-select>
        </el-form-item>
        <el-form-item label="정상 색 표현">
          <el-checkbox v-model="formModel.styleOptions.showNormalColor"></el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">가상 장애 효과</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="관리대상 설정">
          <div :class="$style['div-wrapper']">
            {{ selectedObjCount }}
            <el-button :class="$style.button" @click="onCustomObjectSelectBtnClick">선택</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <w-setting-obj-of-custom-object-popup ref="popup" @close="onPopupClose"></w-setting-obj-of-custom-object-popup>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import WColorField from '@/components/form/ColorField';
import { isEmpty } from '@/utils/basic';

import ObjectProperty from '@/mixins/topologymap/object-property';

import WImageSelect from '@/views/topologymap/components/property/ImageSelect';
import WLabelPositionSelect from '@/views/topologymap/components/property/LabelPositionSelect';
import WSettingObjOfCustomObjectPopup from '@/views/topologymap/components/popup/SettingObjOfCustomObjectPopup';

export default {
  name: 'WCustomObjectProperty',
  components: {
    WColorField,
    WImageSelect,
    WLabelPositionSelect,
    WSettingObjOfCustomObjectPopup,
  },
  mixins: [ObjectProperty],
  computed: {
    selectedObjCount() {
      let resultString = '관리대상 없음';
      if (!isEmpty(this.formModel.objIds)) {
        const length = this.formModel.objIds.length;
        if (length > 0) {
          resultString = `관리대상 ${length} 대`;
        }
      }
      return resultString;
    },
  },
  methods: {
    onCustomObjectSelectBtnClick() {
      this.$refs.popup.open(this.formModel && this.formModel.objIds);
    },
    onPopupClose(newSelectedObjs) {
      this.formModel.objIds = cloneDeep(newSelectedObjs);
    },
  },
};
</script>
<style module>
.div-wrapper {
  display: flex;
  align-items: center;
}
.button {
  position: absolute;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/CustomObjectProperty.vue